import SeoFooter from 'app/shared/modules/SeoFooter';
import Footer from 'app/shared/modules/Footer';
import { fullBleedDesktop, pageFooterContainer, seoFooterInnerPadding } from './pageFooter.styles';

export const PageFooter = () => (
  <div className={pageFooterContainer}>
    <div className={fullBleedDesktop}>
      <SeoFooter hideDivider className={seoFooterInnerPadding} />
      <Footer noMarginTop />
    </div>
  </div>
);
